/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import GlobalSettings, { getRootUrl } from '@/model/global/GlobalSettings'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    form: false
  },
  sort: {
    displayName: 'sectionSort',
    type: IKDataEntity.Types.Integer,
    form: false
  },
  image: {
    type: IKDataEntity.Types.Image,
    formConfig: {
      type: {
        root: () => getRootUrl() + GlobalSettings.dishImageRoot
      },
      hint: 'picProportion'
    },
    displayName: 'image'
  }
}
const config = {
  add: function (item) {
    item.sort = 999
    return hillo.postWithUploadFile('Restaurant.php?op=uploadImage', {
      ...item
    }, { showLoading: true })
  },
  edit: function (item) {
    if (item.file) {
      item.imageExt = item.file.name.split('.')[1]
    }
    return hillo.postWithUploadFile('Restaurant.php?op=modifyRestaurantImage', {
      ...item,
      params: JSON.stringify(item)
    }, {
      showLoading: false,
      silent: true
    })
  },
  remove: function (id) {
    return hillo.post('Restaurant.php?op=deleteRestaurantImage', { id })
  },
  load: async function (filter) {
    return (await hillo.get('Restaurant.php', {
      op: 'showAllRestaurantImage',
      ...filter
    }))
      .content
  }
}

export default IKDataEntity.ModelFactory(entity, config)
